import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EffektButton, EffektButtonVariant } from "../../../../EffektButton/EffektButton";
import { selectReferralAction, setOtherText, submitReferralAction } from "../../../store/referrals/actions";
import { State } from "../../../store/state";
import { ReferralData } from "../../../types/Temp";
import { WidgetPane3ReferralsProps } from "../../../types/WidgetProps";
import { PaneTitle } from "../../panes/Panes.style";
import { ReferralButtonsWrapper, ReferralTextInput } from "../../panes/PaymentPane/Bank/ReferralPane.style";
import { ReferralActionTypes } from "../../../store/referrals/types";
import { Action } from "typescript-fsa";
import { Dispatch } from "@reduxjs/toolkit";
export const Referrals: React.FC<{
  text: WidgetPane3ReferralsProps;
}> = t0 => {
  const $ = _c(21);
  const {
    text
  } = t0;
  const dispatch = useDispatch();
  const referrals = useSelector(_temp);
  const selectedReferrals = useSelector(_temp2);
  const otherText = useSelector(_temp3);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      position: "relative",
      left: "-40px",
      marginTop: "1.5rem",
      paddingBottom: "0.5rem"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      position: "absolute",
      left: "0",
      top: "0"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div style={t1}><svg height="2" width="576" style={t2}><g fill="none" stroke="currentcolor" strokeWidth="1"><path strokeDasharray="12,12" strokeDashoffset="6" d="M0 1 l576 0" /></g>Sorry, your browser does not support inline SVG.</svg></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== text.referrals_title) {
    t4 = <PaneTitle>{text.referrals_title}</PaneTitle>;
    $[3] = text.referrals_title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== dispatch || $[6] !== referrals || $[7] !== selectedReferrals) {
    t5 = referrals?.filter(_temp4).map(ref_0 => <EffektButton squared={true} variant={EffektButtonVariant.SECONDARY} cy={`referral-button-${ref_0.id}`} key={ref_0.id} selected={selectedReferrals.includes(ref_0.id)} useCheckmark={true} onClick={e => {
      if (selectedReferrals.includes(ref_0.id)) {
        const refData = {
          referralID: ref_0.id,
          active: false
        };
        dispatch(selectReferralAction(refData));
        dispatch(submitReferralAction.started(refData));
      } else {
        const refData_0 = {
          referralID: ref_0.id,
          active: true
        };
        dispatch(selectReferralAction(refData_0));
        dispatch(submitReferralAction.started(refData_0));
      }
      e.currentTarget.blur();
    }}>{ref_0.name}</EffektButton>);
    $[5] = dispatch;
    $[6] = referrals;
    $[7] = selectedReferrals;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t5) {
    t6 = <ReferralButtonsWrapper>{t5}</ReferralButtonsWrapper>;
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== dispatch) {
    t7 = e_0 => {
      dispatch(setOtherText(e_0.currentTarget.value));
      if (e_0.currentTarget.value.trim() !== "") {
        dispatch(submitReferralAction.started({
          referralID: 10,
          active: true,
          comment: e_0.currentTarget.value
        }));
      } else {
        dispatch(submitReferralAction.started({
          referralID: 10,
          active: false
        }));
      }
    };
    $[11] = dispatch;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== otherText || $[14] !== t7 || $[15] !== text.other_referral_input_placeholder) {
    t8 = <ReferralTextInput data-cy="referral-text-input" type="text" placeholder={text.other_referral_input_placeholder} value={otherText} onChange={t7} />;
    $[13] = otherText;
    $[14] = t7;
    $[15] = text.other_referral_input_placeholder;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t4 || $[18] !== t6 || $[19] !== t8) {
    t9 = <div>{t3}{t4}{t6}{t8}</div>;
    $[17] = t4;
    $[18] = t6;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  return t9;
};
function _temp(state) {
  return state.referrals.referrals;
}
function _temp2(state_0) {
  return state_0.referrals.selectedReferrals;
}
function _temp3(state_1) {
  return state_1.referrals.otherText;
}
function _temp4(ref) {
  return ref.id !== 10;
}